export const MAX_WORD_LENGTH = 4
export const MAX_CHALLENGES = 5
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
